module.exports = __webpack_public_path__ + "img/jt3.c97b5f97.png";